const Component = () => import('./AccountForm');

export { Component };
